<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/jala-pond";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit JALA Ponds",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('jala_ponds.singular')) }},
    resourceRoute: {default: 'jala_ponds'},
    modelVariable: {default: 'jala_pond'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('jala_ponds.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('jala_ponds.plural')),
          href: "/jala_ponds",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/jala_ponds/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/jala_ponds/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/jala/ponds/${this.$route.params.key}`).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/jala/ponds/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/jala/ponds/${this.$route.params.key}`)
    }
  }
}
</script>
